(function () {
  'use strict';

  var SHEETS_URL =
    'https://script.google.com/macros/s/AKfycbzPl4ntBq2DV3ZQmPu5NvjZwZtlluILA6ckmelFNoORt0m4M0_RBqgvFnCld3w1iACo/exec';

  function sendToSheets(data) {
    return fetch(SHEETS_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data).toString(),
    });
  }

  function fd(formData, key) {
    return formData.get(key) || '';
  }

  // ── Contact pagina formulier (sections/main-contact.liquid) ──
  // Veldnamen: contact[Naam], contact[email], contact[Telefoonnummer], contact[Onderwerp], contact[Reactie]
  function handleContactForm(form) {
    form.addEventListener('submit', function () {
      var data = {
        form_type: 'contact',
        name:    document.getElementById('ContactForm-name')    ? document.getElementById('ContactForm-name').value    : '',
        email:   document.getElementById('ContactForm-email')   ? document.getElementById('ContactForm-email').value   : '',
        phone:   document.getElementById('ContactForm-phone')   ? document.getElementById('ContactForm-phone').value   : '',
        subject: document.getElementById('ContactForm-subject') ? document.getElementById('ContactForm-subject').value : '',
        message: document.getElementById('ContactForm-body')    ? document.getElementById('ContactForm-body').value    : '',
        page:    window.location.href,
      };
      sendToSheets(data);
    });
  }

  // ── Offerte modal formulier op product pagina's (snippets/custom-project-cta.liquid) ──
  // Veldnamen: contact[Naam], contact[email], contact[Telefoonnummer], contact[Bedrijf],
  //            contact[Straat en huisnummer], contact[Postcode], contact[Stad], contact[Reactie]
  //            contact[Product], contact[Product URL], contact[Type]
  function handleOfferteForm(form) {
    form.addEventListener('submit', function () {
      var formData = new FormData(form);
      var data = {
        form_type: 'offerte',
        product:      fd(formData, 'contact[Product]'),
        product_url:  fd(formData, 'contact[Product URL]'),
        type:         fd(formData, 'contact[Type]'),
        name:         fd(formData, 'contact[Naam]'),
        email:        fd(formData, 'contact[email]'),
        phone:        fd(formData, 'contact[Telefoonnummer]'),
        company:      fd(formData, 'contact[Bedrijf]'),
        street:       fd(formData, 'contact[Straat en huisnummer]'),
        zip:          fd(formData, 'contact[Postcode]'),
        city:         fd(formData, 'contact[Stad]'),
        message:      fd(formData, 'contact[Reactie]'),
        page:         window.location.href,
      };
      sendToSheets(data);
    });
  }

  function init() {
    var contactForm = document.getElementById('ContactForm');
    if (contactForm && !contactForm.dataset.sheetsReady) {
      contactForm.dataset.sheetsReady = '1';
      handleContactForm(contactForm);
    }

    document.querySelectorAll('.custom-project-modal__form').forEach(function (form) {
      if (!form.dataset.sheetsReady) {
        form.dataset.sheetsReady = '1';
        handleOfferteForm(form);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Herinitialiseer wanneer een modal geopend wordt (form mogelijk nog niet in DOM)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-modal-open]')) {
      setTimeout(init, 50);
    }
  });
})();
